import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { uiReducer } from './ui';
import { websitesReducer } from './websites';
import { appConfigReducer } from './appConfig';

export const rootReducer = (routerReducer) =>
  combineReducers({
    router: routerReducer,
    form: formReducer,
    ui: uiReducer,
    websites: websitesReducer,
    appConfig: appConfigReducer,
    vmpro: (state = {}) => state,
    isConsumerApp: (state = false) => state,
  });
